import { AnnouncementType, IAnnouncementModel } from '../../../interfaces/IAnnoucementModel';
import {
    GET_PUBLIC_ANNOUNCEMENTS_KEY,
    useGetPublicAnnouncements,
} from '../../../pages/announcement/useGetPublicAnnouncements';
import { useEffect, useState } from 'react';

import { AnnouncementDetail } from './AnnouncementDetail';
import useLocalStorage from '../../../hooks/useLocalStorage';
import { useLocation } from 'react-router-dom';
import { useQueryClient } from 'react-query';

export function PublicAnnouncements() {
    const queryClient = useQueryClient();
    const location = useLocation();
    const publicAnnouncementsQuery = useGetPublicAnnouncements();
    const [globalAnnouncementGuids, setGlobalAnnouncementGuids, removeGlobalAnnouncementGuids] =
        useLocalStorage('GlobalAnnouncementGuids', '');
    const [publicAnnouncements, setPublicAnnouncements] = useState<IAnnouncementModel[]>([]);

    const handleRemoveAnnouncement = (guid: string) => {
        queryClient.setQueryData(
            [GET_PUBLIC_ANNOUNCEMENTS_KEY],
            publicAnnouncementsQuery?.data?.filter((f) => f.guid !== guid)
        );

        setGlobalAnnouncementGuids(
            globalAnnouncementGuids ? `${globalAnnouncementGuids},${guid}` : guid
        );
    };

    useEffect(() => {
        setPublicAnnouncements(
            publicAnnouncementsQuery.data?.filter(
                (a) =>
                    a.announcementTypeId === AnnouncementType.Public &&
                    !globalAnnouncementGuids?.split(',').includes(a.guid)
            ) ?? []
        );
    }, [location.pathname, publicAnnouncementsQuery.data]);

    return (
        <>
            {publicAnnouncements.map((announcement: IAnnouncementModel) => {
                return (
                    <AnnouncementDetail
                        key={announcement.guid}
                        announcement={announcement}
                        onRemoveAnnouncement={handleRemoveAnnouncement}
                    />
                );
            })}
        </>
    );
}
